import { LoadingRow } from '@autopass-web/mochi-component';
import styles from './index.module.scss';

export const PromotionGroupLoading = () => {
  return (
    <div className={styles['promotion-group-loading']}>
      <img src="/assets/icon_star.svg" alt="icon-star" />
      <LoadingRow width="20%" height={18} margin="0 0 8px" />
      <LoadingRow width="100%" height={18} />
    </div>
  );
};

export const PromotionDetailLoading = () => {
  return (
    <div className={styles['promotion-detail-loading']}>
      <LoadingRow width="30%" height={18} margin="0 0 6px" />
      <LoadingRow width="100%" height={18} margin="0 0 30px" />
      <LoadingRow width="70%" height={18} margin="0 0 17px" />
      <LoadingRow width="100%" height={18} margin="0 0 8px" />
      <LoadingRow width="100%" height={18} margin="0 0 8px" />
      <LoadingRow width="100%" height={18} />
    </div>
  );
};

export const PromotionLoading = () => {
  return (
    <div className={styles['promotion-loading']}>
      <div className={styles.bars}>
        <LoadingRow width="40%" height={18} margin="0 0 8px" />
        <LoadingRow width="100%" height={18} margin="0 0 20px" />
        <LoadingRow width="20%" height={18} />
      </div>
      <LoadingRow width="60px" height={60} />
    </div>
  );
};
